import React, { useState, useEffect } from 'react';

import Banner from './Banner'
import Map from './Map'
import POIModal from './POIModal'
import SensorModal from './SensorModal'
import FauneModal from './FauneModal'
import FloreModal from './FloreModal'
import NewsList from './NewsList'
import TabBar from './TabBar'
import SensorsDashboard from './SensorsDashboard'

import * as Api from '../API/API.js';

function Home() {

  const [isVisibleModal, setModalVisible] = useState(4);
  const [currentModalInfos, setCurrentModalInfosToDisplay] = useState({});
  const [allNews, setAllNews] = useState([])
  const [tabBarSelect, setTabBarSelect] = useState(0);

  useEffect(() => {
    Api.fetchNews(0, 1000).then(val => {
      setAllNews(val)
    }).catch(error =>{console.log("fetchNews - ERROR");});      
  }, []);


  return (
    <React.Fragment>
      <div className="container-fluid">
      <div className="row bannerrow">
        <div className="col align-self-center"> 
          <Banner/>
        </div>
     
      </div>

        <div className="row contentrow">
          <div className="col-md-4 leftpanel">
            
              <TabBar 
                setTabBarSelect = {setTabBarSelect}
                tabBarSelect = {tabBarSelect}/>
                
              {tabBarSelect === 0 ? 
               <div className="row newsrow"> <div className="col"> <NewsList news={allNews}/></div></div>  : <div className="row sensorrow"> <div className="col sensorcol"><SensorsDashboard/> </div></div>}
          </div>
          <div className="col-md-8 rightpanel">
            <POIModal
              visible={isVisibleModal === 0}
              setVisibleModalType = {setModalVisible}
              infos = {currentModalInfos}/>
            <SensorModal
              visible={isVisibleModal === 1}
              setVisibleModalType = {setModalVisible}
              infos = {currentModalInfos}/>
            <FauneModal
              visible={isVisibleModal === 2}
              setVisibleModalType = {setModalVisible}
              infos = {currentModalInfos}/>
            <FloreModal
              visible={isVisibleModal === 3}
              setVisibleModalType = {setModalVisible}
              infos = {currentModalInfos}/>
            
            <Map
              setVisibleModalType = {setModalVisible}
              setCurrentModalInfosToDisplay = {setCurrentModalInfosToDisplay}/>         
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default Home;
